import { store } from "react-notifications-component"
import { notificationOptions } from "../api/Definitions"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorNotification(e: any) {
  if (e) {
    if (e.reason === "Nothing changed!") {
      store.addNotification({
        message: e.reason,
        type: "warning",
        ...notificationOptions,
      })
    } else {
      store.addNotification({
        message: e.reason,
        type: "danger",
        ...notificationOptions,
      })
    }
  } else {
    store.addNotification({
      message: "Something went wrong!",
      type: "danger",
      ...notificationOptions,
    })
  }
}
